export enum EnumSourceFunds {
  SALE = '1',
  DONATION = '2',
  BUDGET_ALLOCATION = '3',
  CONTRIBUTIONS = '4',
  FINANCING = '5',
  PROFITS = '6',
  SUBSIDIES = '7',
  RENTS = '8',
  OTHER = '9'
}

export const NAME_SOURCE_FUNDS = {
  1: 'Venta / Prestación de productos / Servicios',
  2: 'Donaciones',
  3: 'Asignación presupuestaria',
  4: 'Aportaciones',
  5: 'Financiamiento',
  6: 'Utilidades',
  7: 'Subvenciones',
  8: 'Rentas',
  9: 'Otro'
}

export const TYPE_SOURCE_FUNDS = {
  SALE: '1',
  DONATION: '2',
  BUDGET_ALLOCATION: '3',
  CONTRIBUTIONS: '4',
  FINANCING: '5',
  PROFITS: '6',
  SUBSIDIES: '7',
  RENTS: '8',
  OTHER: '9'
}

export const CATALOG_SOURCE_FUNDS = [
  {
    value: TYPE_SOURCE_FUNDS.SALE,
    label: NAME_SOURCE_FUNDS[1]
  },
  {
    value: TYPE_SOURCE_FUNDS.DONATION,
    label: NAME_SOURCE_FUNDS[2]
  },
  {
    value: TYPE_SOURCE_FUNDS.BUDGET_ALLOCATION,
    label: NAME_SOURCE_FUNDS[3]
  },
  {
    value: TYPE_SOURCE_FUNDS.CONTRIBUTIONS,
    label: NAME_SOURCE_FUNDS[4]
  },
  {
    value: TYPE_SOURCE_FUNDS.FINANCING,
    label: NAME_SOURCE_FUNDS[5]
  },
  {
    value: TYPE_SOURCE_FUNDS.PROFITS,
    label: NAME_SOURCE_FUNDS[6]
  },
  {
    value: TYPE_SOURCE_FUNDS.SUBSIDIES,
    label: NAME_SOURCE_FUNDS[7]
  },
  {
    value: TYPE_SOURCE_FUNDS.RENTS,
    label: NAME_SOURCE_FUNDS[8]
  },
  {
    value: TYPE_SOURCE_FUNDS.OTHER,
    label: NAME_SOURCE_FUNDS[9]
  }
]
